import {
  LEGACY_MESSAGING_RATES,
  type MessagingRates,
} from "@punchup/data/models";

// Fail-closed legacy default; callers pass gate-resolved `rates` — ui-common
// reads no gates.
export const DEFAULT_CREDIT_RATES: MessagingRates = LEGACY_MESSAGING_RATES;

/**
 * Calculate the number of SMS segments for a given body length.
 * 1 segment for ≤160 chars, ceil(length/153) for longer messages.
 */
export function calculateSmsSegments(bodyLength: number): number {
  if (bodyLength <= 0) return 1;
  if (bodyLength <= 160) return 1;
  return Math.ceil(bodyLength / 153);
}

export interface EstimateMessagingCostParams {
  paidEmailCount: number;
  paidSmsCount: number;
  smsBodyLength: number;
  emailEnabled: boolean;
  smsEnabled: boolean;
  rates?: MessagingRates;
}

export interface CostEstimate {
  emailCost: number;
  smsCost: number;
  totalCost: number;
  smsSegments: number;
}

/**
 * Estimate the total credit cost for a messaging job.
 * Only paid (imported) contacts cost credits. Punchup subscribers are free for email.
 * SMS always costs credits regardless of contact source.
 */
export function estimateMessagingCost({
  paidEmailCount,
  paidSmsCount,
  smsBodyLength,
  emailEnabled,
  smsEnabled,
  rates = DEFAULT_CREDIT_RATES,
}: EstimateMessagingCostParams): CostEstimate {
  const smsSegments = calculateSmsSegments(smsBodyLength);
  const emailCost = emailEnabled ? paidEmailCount * rates.email : 0;
  const smsCost = smsEnabled ? paidSmsCount * smsSegments * rates.sms : 0;

  return {
    emailCost,
    smsCost,
    totalCost: emailCost + smsCost,
    smsSegments,
  };
}
